import { render, staticRenderFns } from "./resetPasswordDialogComponent.vue?vue&type=template&id=3a080bea"
import script from "./resetPasswordDialogComponent.vue?vue&type=script&lang=js"
export * from "./resetPasswordDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports